import { Chip, type ChipProps } from '@mui/material'

function CustomChip({ ...restProps }: ChipProps) {
  return <Chip clickable size="medium" color="secondary" {...restProps} />
}
export default CustomChip
